module.exports = __webpack_public_path__ + "static/img/23.0c367c40.png";